<template>
<category-factor-chart-group
  v-if="dataList.length > 0"
  :factor-group-map="factorGroupMap"
  :data-config="dataList[0]"
  :unit-prop="unitProp"
  :show-header="false"
  :not-complete-data="false"
  :is-show-total="false"
  current-level
  class="audit-VOCs-compare-chart-wrapper"
/>
</template>

<script>
import BaseCompare from './BaseCompare'
import CategoryFactorChartGroup from '../../../../components/Data/ChartWrapper/CategoryFactorChartGroup'

export default {
  name: 'AuditVOCDeviceCompareChart',
  extends: BaseCompare,
  components: {CategoryFactorChartGroup},
  props: {
    auditDataList: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      unitProp: 'stdUnit'
    }
  },
  computed: {
    valueProp: () => 'autoValue'
  },
  methods: {
    getData () {

    },
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'bar',
        stack: dimensionIds[dimension],
        barMaxWidth: 30
      }
    }
  },
  watch: {
    auditDataList: {
      immediate: true,
      handler (auditDataList) {
        clearTimeout(this.setDataListTimer)
        this.setDataListTimer = setTimeout(() => {
          this.setDataList(auditDataList.map(el => {
            if (el.auditFlag === 'DELETE' || (el.dasFlag === 'c' || el.dasFlag === 'C')) {
              el[this.valueProp] = ''
            }

            return el
          }))
        }, 0)
      }
    }
  }
}
</script>

<style lang="scss">
.audit-VOCs-compare-chart-wrapper {
  height: 100%;
  padding-top: 10px;

  .xy-chart-wrapper {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditDeviceViews/AuditVOCDeviceCompareChart.vue